import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { Translate } from 'react-localize-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { lastSubjectActions } from '../../../store/lastSubjectsStore'
import WidgetRow from './widgetRow';
import classnames from "classnames";
import Message from '../../common/message';
import CrossIcon from '../../../img/icons/Cross';
import { isNullOrUndefined } from '../../../store/storeFunctions';

class LastSearchedSubjectsWidget extends React.Component {
    componentDidMount() {
        if (isNullOrUndefined(this.props.lastSearchedSubjects) || this.props.lastSearchedSubjects.length === 0)
            this.props.getSubjects();
    }

    reloadSubjects = () => {
        this.props.getSubjects();
    }

    render() {
        return (
            <article className="panel">
                <div className="panel-heading">
                    <div className='panel-heading-title'>
                        <div style={{marginRight:'auto', marginTop:'auto', marginBottom:'auto'}}><Translate id='Search.LastSubjects' /></div>
                        <CrossIcon className='icon-centered' onClick={this.props.closePanel} style={{marginLeft: '.5em'}} />
                    </div>
                </div>
                <div className={classnames({'search-progress': true, 'searching': this.props.isLoading})}></div>
                <div className="panel-block">
                    {this.renderContent()}
                </div>
            </article>
        );
    }

    renderContent = () => {
        return (<>
            {!this.props.isLoading && this.props.lastSearchedSubjects.length === 0 && (
                <div style={{fontSize:'.9em', display:'flex', paddingTop: "1em", paddingLeft: "1em", paddingRight: "0.5em"}}>
                    <Translate id='Search.LastSubjects.NoSubjects' />
                    <FontAwesomeIcon onClick={this.reloadSubjects} className='svg-standard-color' icon='sync' style={{fontSize:'1.25em', marginLeft:'auto', cursor:'pointer'}} />
                </div>
            )}
            {!this.props.isLoading && !this.props.error && this.props.lastSearchedSubjects.slice(0,20).map(s =><WidgetRow key={s.entityId} subject={s} maxTableWidth={this.props.maxWidth - 30} />)}
            {!this.props.isLoading && this.props.error && (
                <div className="error-container" style={{padding:0, fontSize:'.9em'}}>
                    <Message type={'warning'} message={<Translate id={this.props.error} />} />
                </div>
            )}
        </>);
    }
}


export default withRouter(connect(
    state => ({...state.lastSubjects}),
    dispatch => bindActionCreators(lastSubjectActions, dispatch),
)(LastSearchedSubjectsWidget));
